//import type {App} from 'vue';
const helper = {};

helper.formatDate = (string, isDateFormat = false, fromExport = false) => {
    if(string){
        let date;
        if(!isDateFormat){
            date = new Date(string);
        } else {
            date = string;
        }
        if(fromExport){
            return new Intl.DateTimeFormat('default', {dateStyle: 'short'}).format(date);    
        } 
        // Then specify how you want your dates to be formatted
        return new Intl.DateTimeFormat('default', {dateStyle: 'long'}).format(date);
    }
}

helper.formatPrice = (value, decimalPoints = 2) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: decimalPoints === 0 ? 0 : decimalPoints,
        maximumFractionDigits: decimalPoints === 0 ? 0 : decimalPoints,
    });
    return formatter.format(value);
};

helper.formatPercentage = (value) => {
    // Convert the input to a number, defaulting to 0 if it's not valid
    value = Number(value) || 0;
    
    // Create a new Intl.NumberFormat instance for percentage formatting
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    // Format and return the value
    return formatter.format(value);
};

helper.formatPL = (amount, percentage) => {
    // Ensure amount and percentage are numbers, default to 0 if undefined or invalid
    amount = Number(amount) || 0;
    percentage = Number(percentage) || 0;

    // Format the amount with 'K' for thousands, handling negative numbers
    function formatAmount(amount) {
        const absAmount = Math.abs(amount); // Work with the absolute value
        let formattedAmount;
        
        if (absAmount >= 100000) {
            formattedAmount = `₹${(absAmount / 1000).toFixed(1)}K`;
        } else {
            formattedAmount = `₹${absAmount.toFixed(2)}`;
        }

        // Add negative sign if the original amount was negative
        return amount < 0 ? `-${formattedAmount}` : formattedAmount;
    }

    // Format the amount and percentage
    const formattedAmount = formatAmount(amount);
    const formattedPercentage = `${percentage.toFixed(0)}%`;

    // Return the formatted string
    return `${formattedAmount} / ${formattedPercentage}`;
};

helper.formatOptionsArray = (jsonArray, code, label) => {
    let optionsArray = [];
    if(typeof code == 'undefined' || typeof label == 'undefined'){
        const jsonObj = JSON.parse(jsonArray);
        if(jsonObj.length > 0){
        jsonObj.forEach(element => {
            const [first] = element;
            const [second] = element;
            optionsArray[first] = second;
        });
        }
    } else {
        const jsonObj = jsonArray;
        if(jsonObj.length > 0){
            jsonObj.forEach(element => {
                optionsArray[element[code]] = element[label];              
            });
        }
    }
    return optionsArray;  
}

helper.formatOptions = (optionList, value) => {
    return optionList[value] || '';
}

helper.formatTitle = (string) => {
    if(string){
        return (string.charAt(0).toUpperCase() + string.slice(1)).replace('_', ' ');
    }
}

helper.optionArray = (jsonArray, code, label) => {
    let optionsArray = [];
    let jsonObj;
    if(typeof jsonArray == 'string'){
        jsonObj = JSON.parse(jsonArray);
    } else {
        jsonObj = jsonArray;
    }
    if(jsonObj.length > 0){
      jsonObj.forEach(element => {
        if(typeof code == 'undefined' || typeof label == 'undefined'){
            for (var key in element) {
                optionsArray.push({label: element[key], code: key});    
            }
        } else {
            optionsArray.push({label: element[label], code: element[code]});
        }
      });
    }
    return optionsArray;  
}

helper.getSelectedPlatformOptions = () => {
    if(localStorage.getItem('platform')){
        return JSON.parse(localStorage.getItem('platform'));
    }
    return ['0'];
}

helper.getBooleanOption = (blackOption) => {
    let optionsArray = [];
    blackOption = blackOption || false;
    if(blackOption){
        optionsArray.push({'code': '-1', 'label': 'Select Option'});
    }
    optionsArray.push({'code': '1', 'label': 'Enable'});
    optionsArray.push({'code': '0','label': 'Disable'});
    return optionsArray;
}

export default {
    install: (app) => {
        app.config.globalProperties.$helper = helper; 
    },
};
